import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteGuard } from "@/components/auth/RouteGuard";

export const Route = createFileRoute("/_authenticated/vendor-returns")({
  component: () => (
    <RouteGuard module="grns" permission={["view_vendor_returns"]}><Outlet /></RouteGuard>
  ),
});
